/* Imparando Mate — Theme JS
   Cart AJAX, toast, drawer, mobile nav, Matero chat */

(function() {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 4900; // €49 in cents

  /* ── UTILS ─────────────────────────────────────────────── */

  window.formatMoney = function(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  };

  function showToast(message, duration) {
    duration = duration || 2200;
    var container = document.getElementById('ToastContainer');
    if (!container) return;
    var toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = message;
    container.appendChild(toast);
    setTimeout(function() {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(8px)';
      toast.style.transition = 'opacity 200ms, transform 200ms';
      setTimeout(function() { toast.remove(); }, 250);
    }, duration);
  }

  /* ── CART ───────────────────────────────────────────────── */

  window.addToCart = function(variantId, qty, evt) {
    if (evt) evt.preventDefault();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
    .then(function(res) { return res.json(); })
    .then(function(item) {
      if (item.status === 422) {
        showToast('Prodotto non disponibile.');
        return;
      }
      showToast(item.title + ' aggiunto al carrello 🧉');
      refreshCart();
      openCart();
    })
    .catch(function() { showToast('Errore. Riprova.'); });
  };

  function refreshCart() {
    fetch('/cart.js')
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      updateCartBadge(cart.item_count);
      renderCartItems(cart);
      updateCartTotals(cart);
      updateShippingProgress(cart.total_price);
    });
  }

  function updateCartBadge(count) {
    var badge = document.getElementById('CartBadge');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  }

  function renderCartItems(cart) {
    var body = document.getElementById('CartItems');
    var empty = document.getElementById('CartEmpty');
    var footer = document.getElementById('CartFooter');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '';
      if (empty) empty.style.display = 'flex';
      if (footer) footer.style.display = 'none';
      return;
    }

    if (empty) empty.style.display = 'none';
    if (footer) footer.style.display = 'flex';

    body.innerHTML = cart.items.map(function(item) {
      return '<div class="cart-item">' +
        '<img src="' + (item.image ? item.image.replace('_1x1', '_160x160') : '') + '" alt="' + escHtml(item.title) + '" class="cart-item__img" width="84" height="84" loading="lazy">' +
        '<div class="cart-item__info">' +
          '<p class="cart-item__title">' + escHtml(item.product_title) + '</p>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<p style="font-size:var(--text-xs);color:var(--color-text-muted);">' + escHtml(item.variant_title) + '</p>' : '') +
          '<div class="cart-item__bottom">' +
            '<div class="qty-stepper" style="transform:scale(.85);transform-origin:left center;">' +
              '<button class="qty-stepper__btn" onclick="window.updateCartItem(' + item.key + ', ' + (item.quantity - 1) + ')">−</button>' +
              '<input class="qty-stepper__input" value="' + item.quantity + '" readonly style="width:32px;">' +
              '<button class="qty-stepper__btn" onclick="window.updateCartItem(' + item.key + ', ' + (item.quantity + 1) + ')">+</button>' +
            '</div>' +
            '<span class="price__current" style="font-size:var(--text-sm);">' + window.formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button onclick="window.updateCartItem(\'' + item.key + '\', 0)" aria-label="Rimuovi" style="align-self:flex-start;color:var(--color-text-muted);transition:color var(--dur-base);" onmouseover="this.style.color=\'var(--danger-600)\'" onmouseout="this.style.color=\'var(--color-text-muted)\'">' +
          '<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>' +
        '</button>' +
      '</div>';
    }).join('');
  }

  window.updateCartItem = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      updateCartBadge(cart.item_count);
      renderCartItems(cart);
      updateCartTotals(cart);
      updateShippingProgress(cart.total_price);
    });
  };

  function updateCartTotals(cart) {
    var subtotal = document.getElementById('CartSubtotal');
    var total    = document.getElementById('CartTotal');
    if (subtotal) subtotal.textContent = window.formatMoney(cart.total_price);
    if (total)    total.textContent    = window.formatMoney(cart.total_price);
  }

  function updateShippingProgress(totalCents) {
    var fill  = document.getElementById('ShippingFill');
    var label = document.getElementById('ShippingLabel');
    var gap   = document.getElementById('ShippingGap');
    var prog  = document.getElementById('ShippingProgress');
    if (!fill) return;

    var pct = Math.min((totalCents / FREE_SHIPPING_THRESHOLD) * 100, 100);
    fill.style.width = pct + '%';

    if (totalCents >= FREE_SHIPPING_THRESHOLD) {
      if (label) label.innerHTML = '🎉 Spedizione gratuita!';
      if (prog) prog.style.opacity = '.7';
    } else {
      var remaining = FREE_SHIPPING_THRESHOLD - totalCents;
      if (gap) gap.textContent = window.formatMoney(remaining);
      if (label) label.innerHTML = 'Mancano <strong id="ShippingGap">' + window.formatMoney(remaining) + '</strong> alla spedizione gratuita';
    }
  }

  /* ── CART DRAWER ────────────────────────────────────────── */

  window.openCart = function() {
    var drawer = document.getElementById('CartDrawer');
    var overlay = document.getElementById('CartOverlay');
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  };

  window.closeCart = function() {
    var drawer = document.getElementById('CartDrawer');
    var overlay = document.getElementById('CartOverlay');
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  };

  /* ── MOBILE NAV ─────────────────────────────────────────── */

  function openMobileNav() {
    var nav = document.getElementById('MobileNav');
    var toggle = document.getElementById('MobileNavToggle');
    if (!nav) return;
    nav.classList.add('open');
    nav.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    var nav = document.getElementById('MobileNav');
    var toggle = document.getElementById('MobileNavToggle');
    if (!nav) return;
    nav.classList.remove('open');
    nav.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  /* ── MATERO CHAT ────────────────────────────────────────── */

  var MATERO_ENDPOINT = '/apps/matero'; // Change to your actual proxy endpoint

  window.closeMatero = function() {
    var panel = document.getElementById('MateroPanel');
    var launcher = document.getElementById('MateroLauncher');
    if (panel) { panel.classList.remove('open'); panel.setAttribute('aria-hidden', 'true'); }
    if (launcher) launcher.setAttribute('aria-expanded', 'false');
  };

  function toggleMatero() {
    var panel = document.getElementById('MateroPanel');
    var launcher = document.getElementById('MateroLauncher');
    if (!panel) return;
    var isOpen = panel.classList.contains('open');
    if (isOpen) {
      window.closeMatero();
    } else {
      panel.classList.add('open');
      panel.setAttribute('aria-hidden', 'false');
      if (launcher) launcher.setAttribute('aria-expanded', 'true');
      var input = document.getElementById('MateroInput');
      if (input) input.focus();
    }
  }

  function appendChatBubble(text, role) {
    var msgs = document.getElementById('MateroMessages');
    if (!msgs) return;
    var div = document.createElement('div');
    div.className = 'chat-bubble chat-bubble--' + (role === 'user' ? 'user' : 'bot');
    div.textContent = text;
    msgs.appendChild(div);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function sendMateroMessage(text) {
    if (!text.trim()) return;
    appendChatBubble(text, 'user');

    // Typing indicator
    var typing = document.createElement('div');
    typing.className = 'chat-bubble chat-bubble--bot';
    typing.id = 'MateroTyping';
    typing.textContent = '…';
    document.getElementById('MateroMessages').appendChild(typing);

    fetch(MATERO_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: text })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      typing.remove();
      appendChatBubble(data.reply || data.message || 'Scusa, riprova!', 'bot');
    })
    .catch(function() {
      typing.remove();
      appendChatBubble('Non riesco a rispondere ora. Scrivimi su Instagram! 🧉', 'bot');
    });
  }

  window.materoQuickReply = function(text) {
    var input = document.getElementById('MateroInput');
    if (input) input.value = text;
    sendMateroMessage(text);
    if (input) input.value = '';
  };

  /* ── HELPERS ────────────────────────────────────────────── */

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── INIT ───────────────────────────────────────────────── */

  document.addEventListener('DOMContentLoaded', function() {

    // Cart toggle
    var cartToggle = document.getElementById('CartToggle');
    if (cartToggle) cartToggle.addEventListener('click', window.openCart);

    var cartClose = document.getElementById('CartClose');
    if (cartClose) cartClose.addEventListener('click', window.closeCart);

    var cartOverlay = document.getElementById('CartOverlay');
    if (cartOverlay) cartOverlay.addEventListener('click', window.closeCart);

    // Mobile nav
    var mobileToggle = document.getElementById('MobileNavToggle');
    if (mobileToggle) mobileToggle.addEventListener('click', openMobileNav);

    var mobileClose = document.getElementById('MobileNavClose');
    if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);

    var mobileOverlay = document.querySelector('#MobileNav .mobile-nav__overlay');
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);

    // Matero launcher
    var materoLauncher = document.getElementById('MateroLauncher');
    if (materoLauncher) materoLauncher.addEventListener('click', toggleMatero);

    var materoSend = document.getElementById('MateroSend');
    var materoInput = document.getElementById('MateroInput');
    if (materoSend && materoInput) {
      materoSend.addEventListener('click', function() {
        sendMateroMessage(materoInput.value);
        materoInput.value = '';
      });
      materoInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          sendMateroMessage(materoInput.value);
          materoInput.value = '';
        }
      });
    }

    // Escape key closes overlays
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      window.closeCart();
      closeMobileNav();
      window.closeMatero();
    });

    // Initial cart badge
    refreshCart();
  });

})();
